/**
 * Hand-drawn "grading pen" underline. The animation library targets any
 * element with [data-grade-underline] and draws its inner path on scroll.
 * Falls back cleanly (visible instantly) when JS or animations are off.
 */
export function GradeUnderline({ className = "" }: { className?: string }) {
  return (
    <svg
      data-grade-underline
      viewBox="0 0 300 14"
      preserveAspectRatio="none"
      aria-hidden="true"
      className={`block w-full h-[0.35em] mt-1 ${className}`}
    >
      <path
        d="M2 8 C 60 2, 120 12, 180 6 S 280 10, 298 5"
        fill="none"
        stroke="var(--color-grade)"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}